import React from 'react'

import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faPenToSquare } from '@fortawesome/pro-light-svg-icons'
import clsx from 'clsx'

import { ActionLink } from '@infura/packages.ui/ActionLink'
import { Heading } from '@infura/packages.ui/Heading'
import { Loader } from '@infura/packages.ui/Loader'
import { SemanticIcon } from '@infura/packages.ui/SemanticIcon'

type ActiveCardProps = {
  sectionTitle?: string
  icon: IconDefinition
  title: string
  description: React.ReactNode
  onClick?: () => void
  className?: string
}

export const ActiveCard = ({ className, description, icon, onClick, sectionTitle, title }: ActiveCardProps) => (
  <div className={className}>
    {sectionTitle ? (
      <Heading className='mb-4' data-testid='billing-card-section-title' theme='card'>
        {sectionTitle}
      </Heading>
    ) : null}
    <div
      className={clsx('border-border-muted bg-background-alternative flex items-center gap-x-2 rounded-md border p-4')}
    >
      <div>
        <SemanticIcon icon={icon} theme='alternative' />
      </div>
      <div className='flex flex-col'>
        {title ? (
          <p className='m-0 font-bold' data-testid='billing-card-title'>
            {title}
          </p>
        ) : (
          <Loader className='h-4 w-24' />
        )}
        {!!description ? <div className='flex'>{description}</div> : <Loader className='h-4 w-36' />}
      </div>
      {onClick ? (
        <div className='ml-auto self-start'>
          <ActionLink
            data-testid='billing-edit-card'
            icon={faPenToSquare}
            iconPosition='left'
            onClick={e => {
              e.stopPropagation()
              onClick()
            }}
            title='Edit Card info'
          >
            Edit
          </ActionLink>
        </div>
      ) : null}
    </div>
  </div>
)
